import _Vue from "vue";
import {FaizTuruEntity} from "@/entity/FaizTuruEntity";
import {BankaHesabiEntity} from "@/entity/BankaHesabiEntity";
import {BorcluEntity} from "@/entity/BorcluEntity";
import {TakipTipiEntity} from "@/entity/TakipTipiEntity";
import {ParaBirimiEntity} from "@/entity/ParaBirimiEntity";
import {AdresTuru} from "@/enum/AdresTuru";
import {AlacakEntity} from "@/entity/AlacakBelgeler/AlacakEntity";
import AlacakKalemiEntity from "@/entity/AlacakBelgeler/AlacakKalemiEntity";
import {AlacakKalemiAlani, AlacakKalemiAlaniLabel} from "@/enum/AlacakKalemiAlani";
import {KisiEntity} from "@/entity/KisiEntity";
import {KurumEntity} from "@/entity/KurumEntity";
import {AdresEntity} from "@/entity/AdresEntity";
import {store} from "@/store";
import {AxiosResponse} from "axios";
import {StatusCodeHelper} from "@/helpers/StatusCodeHelper";
import app from "@/main";
import {AlacakliEntity} from "@/entity/AlacakliEntity";
import {AlacakBelgeTuru} from "@/enum/AlacakBelgeTuru";
import Crypto from "crypto";
//@ts-ignore
import {EvrakB64FileObject} from "@/plugins/uyap-plugin/evrak_gonder/EvrakGonder";
import {PathToProduct, Product} from "@/enum/Product";
import {LisansEntity} from "@/entity/LisansEntity";
import {
    etkinLisansDurumu,
    etkinUrunEkranlariAcikMi,
    islemKisitliMi,
    islemKisitSebebi,
    KisitliIslem,
    kisitliKalanGun,
    LisansDurum,
    ozellikAcikMi,
    VARSAYILAN_KISIT_GUN,
} from "@/utils/lisansKisit";
import Swal from "sweetalert2";
import CACHE_STORAGE_ICW from "sls-cache";
// @ts-ignore
import "@/utils/html2udf.js";
import {saveAs} from "file-saver";
import {TAKSIT_TABLO_HEADERS, TAKSIT_TABLO_TUTAR_ALANLARI, TAKSIT_TABLO_PDF_KOLON_AGIRLIK, TAKSIT_TABLO_PDF_BASLIK} from "@/helpers/taksitTabloHeaders";

export class Helper {
    [x: string]: any;

    private getBlobFromAxiosResponse(response: any): Blob {
        if (response instanceof Blob) {
            return response;
        }
        if (response?.data instanceof Blob) {
            return response.data;
        }
        return new Blob([response], {type: 'application/octet-stream'});
    }

    /** Content-Disposition: filename* (RFC 5987) öncelikli, yoksa filename=; aksi halde fallback */
    private filenameFromContentDisposition(header: string | undefined | null, fallback: string): string {
        if (!header || typeof header !== 'string') {
            return fallback;
        }
        const cd = header.trim();
        const star = /\bfilename\*\s*=\s*(?:UTF-8|utf-8|[\w-]+)?''([^;\n]+)/i.exec(cd);
        if (star && star[1]) {
            const raw = star[1].trim().replace(/^["']|["']$/g, '');
            if (raw) {
                try {
                    const decoded = decodeURIComponent(raw);
                    if (decoded) return decoded;
                } catch {
                    return raw;
                }
            }
        }
        const quoted = /\bfilename\s*=\s*"((?:\\.|[^"\\])*)"/i.exec(cd);
        if (quoted && quoted[1]) {
            return quoted[1].replace(/\\(.)/g, '$1');
        }
        const plain = /\bfilename\s*=\s*([^;\n]+)/i.exec(cd);
        if (plain && plain[1]) {
            const v = plain[1].trim().replace(/^["']|["']$/g, '');
            if (v) return v;
        }
        return fallback;
    }

    private downloadNameFromResponse(response: AxiosResponse, fallback: string): string {
        const h = response.headers || {};
        const cd = (h['content-disposition'] || h['Content-Disposition']) as string | undefined;
        return this.filenameFromContentDisposition(cd, fallback);
    }

    private saveBlob(blob: Blob, name: string) {
        saveAs(blob, name);
    }

    private appendDownloadName(url: string, downloadName?: string): string {
        if (!downloadName) {
            return url;
        }

        const separator = url.includes('?') ? '&' : '?';
        return `${url}${separator}download_name=${encodeURIComponent(downloadName)}`;
    }

    async downloadGeneratedFile(fileMeta: any, returnFile: boolean = false, fallbackFileName: string = 'download.xml'): Promise<File | void> {
        if (!fileMeta?.download_url) {
            throw new Error(fileMeta?.message || 'Dosya indirilemedi');
        }

        const fileName = fileMeta.download_name || fileMeta.filename || fallbackFileName;
        const downloadUrl = this.appendDownloadName(`/api/${fileMeta.download_url}`, fileMeta.download_name);
        const blob = await this.getBlobFromLink(downloadUrl);
        const mimeType = blob.type || 'application/xml';

        if (returnFile) {
            return new File([blob], fileName, {type: mimeType});
        }

        this.saveBlob(blob, fileName);
    }

    async requestXmlFile(url: string, options: {method?: 'GET' | 'POST'; data?: any; returnFile?: boolean; fallbackFileName?: string} = {}): Promise<File | void> {
        const {
            method = 'GET',
            data = null,
            returnFile = false,
            fallbackFileName = 'download.xml'
        } = options;

        const response = method === 'POST'
            ? await app.$http.post(url, data)
            : await app.$http.get(url);

        const fileMeta = response?.data ? response.data : response;
        return this.downloadGeneratedFile(fileMeta, returnFile, fallbackFileName);
    }

    async logout() {
        // Anket panelindeki program-kokenli oturumlari kapat (back-channel).
        // Token temizlenmeden ONCE, kisa timeout'la beklenir; anket
        // erisilemezse logout bloklanmaz (fail-open).
        await this.anketOturumlariniKapat();
        localStorage.clear();
        sessionStorage.clear();
        this.userData = null;
        location.href = app.$store.state.ssoUri + "force-logout?redirect_uri=" + location.origin + "/giris";
    }

    private async anketOturumlariniKapat(): Promise<void> {
        const accessToken = localStorage.getItem("accessToken");
        if (!accessToken) return;
        try {
            const controller = new AbortController();
            const timer = setTimeout(() => controller.abort(), 2000);
            const init: any = {
                method: "POST",
                headers: { Authorization: "Bearer " + accessToken },
                // Navigasyon baslasa bile istegin tamamlanmasi icin.
                keepalive: true,
                signal: controller.signal
            };
            await fetch("/api/v1/oauth/anket-logout", init);
            clearTimeout(timer);
        } catch (e) {
            console.error("Anket oturumları kapatılamadı:", e);
        }
    }

    isAuthorized(key: string): boolean {
        let user = store.state.user;
        if (user?.roles) {
            if (user.roles[0].is_admin == 1) return true;
            let userPermissions = user.roles[0]?.permissions;
            if (userPermissions) {
                return userPermissions.find((permission: any) => permission.name === key);
            }
        }
        return false;
    }

    async requestWithCache(url: string,data: any = {} , method: "GET"|"POST" = "GET"): Promise<AxiosResponse>{
        let response;
        let cacheKey = this.hash(url);
        let cachedData = CACHE_STORAGE_ICW.get<any>(cacheKey);
        if (cachedData) {
            response = cachedData;
        } else {
            if(method == "GET")
                response = await app.$http.get(url);
            else
                response = await app.$http.post(url,data);
            CACHE_STORAGE_ICW.set(cacheKey, response, 60);
        }
        return response;
    }

    /**
     * DEV-2113 — urun bazli ETKIN lisans durumu. Taban urun mirasi (OfisPro, ust
     * urun gecerliyse acilir) sunucuda hesaplanir; buradan /ben ozetindeki
     * urun_durumlari kaynak alinir (tek kanonik kaynak). Ozet yoksa licenses[]
     * end_date'e duser.
     */
    lisansDurumu(urun: Product | PathToProduct): LisansDurum {
        return etkinLisansDurumu(store.getters.ozellikDurumu, store.getters.licenses, urun, this.lisansKisitGun());
    }

    /** Kullanici bu urunun ekranlarina girebilir mi? Kisitli donemde EVET; etkin duruma gore. */
    lisansEkranlariAcikMi(urun: Product | PathToProduct): boolean {
        return etkinUrunEkranlariAcikMi(store.getters.ozellikDurumu, store.getters.licenses, urun, this.lisansKisitGun());
    }

    /**
     * Kisitli donemde kalan gun ("N gun sonra kisitli mod sona erecek"). ETKIN
     * durum kisitli degilse (ust urun devrede ya da gecerli) null: ust urun
     * OfisPro'yu actiginda ayri bir "yenile" uyarisi cikmaz.
     */
    lisansKisitliKalanGun(urun: Product | PathToProduct): number | null {
        if (this.lisansDurumu(urun) !== "kisitli") return null;
        return kisitliKalanGun(store.getters.licenses, urun, this.lisansKisitGun());
    }

    /**
     * Bu islem lisans yuzunden kapali mi? (buton :disabled) Karari sunucu verir:
     * /ben -> ozellik_durumu.kapali_islemler (buro istisnasi dahil).
     */
    lisansIslemKisitli(islem: KisitliIslem): boolean {
        return islemKisitliMi(store.getters.ozellikDurumu, islem);
    }

    /** Kapaliysa sebebi, degilse bos string. (buton :tooltip) */
    lisansIslemSebebi(islem: KisitliIslem): string {
        return islemKisitSebebi(store.getters.ozellikDurumu, islem);
    }

    /** Ozellik bu buroda acik mi? Varsayilan acik; kapaliysa menude gorunmez, sayfasi "aktif degil" der. */
    ozellikAcikMi(anahtar: string): boolean {
        return ozellikAcikMi(store.getters.ozellikDurumu, anahtar);
    }

    /** Kisit suresi sunucudan gelir; buraya kopyalanmaz (bkz. lisansKisit.ts). */
    lisansKisitGun(): number {
        return Number(store.getters.userData?.lisans_kisit_gun) || VARSAYILAN_KISIT_GUN;
    }

    licenceIsValid(urun: Product|PathToProduct): boolean {
        //let productLicence: LisansEntity = store.getters.licenses.find((licence: LisansEntity) => licence.product_id == urun);
        let productLicence: LisansEntity | undefined =
            [...store.getters.licenses]
                .reverse()
                .find((licence: LisansEntity) => licence.product_id == urun);
        if (productLicence) {
                //SADECE END DATE E BAKSIN ZATEN API KONTROL EDIYOR
            return (new Date(productLicence.end_date).getTime() >= new Date().getTime())
        } else {
            return false;
        }
    }

    tarihFarkiGunSayisi(begin: Date, end: Date) {
        var date1 = new Date(begin.toISOString().substr(0, 10));
        var date2 = new Date(end.toISOString().substr(0, 10));
        let num = (date2.getTime() - date1.getTime()) / 86400000;
        return num;
    }

    tarihSaatStr(val: Date | null, convertToUtc3: boolean = false): string {
        if (val === null) {
            return "";
        }
        try {
            let date:any = val;
            if (convertToUtc3){
                let convertedDate= new Date(date).setHours(new Date(date).getHours() + 3);
                date = new Date(convertedDate).toISOString();
            }
            return this.tarihStr(date) + " " + this.saatStr(date);
        } catch (e) {
            return "";
        }
    }

    hash(obj:any){
        return Crypto.createHash('sha1').update(JSON.stringify(obj)).digest().toString('hex');
    }

    getNestedValue(obj: any, key: string) {
        return key.split('.').reduce((o, i) => o[i], obj);
    }

    async clickCopyText(str: string) {
        try {
            await navigator.clipboard.writeText(str);
            app.$toast("Metin kopyalandı");
        } catch (e) {
            app.$toast.error("Metin kopyalanamadı");
        }
    }

    tarihStr(val: Date | string): string {
        try {
            if (typeof val === "string") { //
                return val.substr(0, 10).split('-').reverse().join('/');
            } else if (typeof val === "object") {
                return val.toISOString().substr(0, 10).split('-').reverse().join('/');
            }
        } catch (e) {
        }
        return "";
    }

    saatStr(val: Date | string): string {
        try {
            if (typeof val === "string") {
                return val.substr(11, 8);
            } else if (typeof val === "object") {
                return val.toISOString().substr(11, 5);
            }
        } catch (e) {
        }
        return "";
    }

    kisiKurumAd(val: any): string {
        if (val == null) {
            return "";
        }
        if (val.kisi != null) {
            return val.kisi.ad + ' ' + val.kisi.soyad;
        } else if (val.kurum != null) {
            return val.kurum.sirket_adi;
        } else {
            return ""
        }

    }
    newKisiKurumAdState(val: any) {
        if (val.borclu_bilgileri == null) {
            return "";
        }
        if (val.kisi_id != null) {
            return val.borclu_bilgileri.ad + ' ' + val.borclu_bilgileri.soyad;
        } else if (val.kurum_id != null) {
            return val.borclu_bilgileri.sirket_adi;
        }

    }

    kisiKurumVarsayilanAdres(val: any): AdresEntity | null {
        if (val == null) {
            return null;
        }
        if (val.kisi != null) {
            let kisi: KisiEntity = val.kisi;
            return kisi.varsayilan_adres;
        } else if (val.kurum != null) {
            let kurum: KurumEntity = val.kurum;
            return kurum.varsayilan_adres;
        }
        return null;
    }


    hesapNoOrIbanStr(row: BankaHesabiEntity): string {
        if (row.iban) {
            return row.iban === null ? "" : row.iban;
        } else {
            return row.sube_adi + " - " + row.hesap_no;
        }
    }

    tcknOrVergiNo(val: any): string {
        if (val == null) {
            return "";
        }
        if (val.kisi != null) {
            return val.kisi.tc_kimlik_no
        }
        if (val.kurum != null) {
            if (val.kurum.vergi_no) {
                return val.kurum.vergi_no.toString();
            }
            return "";
        }
        return ""
    }
    newStatetcknOrVergiNo(val: any): string {
        if (val == null) {
            return "";
        }
        if (val.kisi_id != null) {
            return val.borclu_bilgileri.tc_kimlik_no
        }
        if (val.kurum_id != null) {
            if (val.borclu_bilgileri.vergi_no) {
                return val.borclu_bilgileri.vergi_no.toString();
            }
            return "";
        }
        return ""
    }

    takipTipiStr(takipTipi: TakipTipiEntity): string {
        return takipTipi ? takipTipi.no + " (" + takipTipi.eski_no + ") - " + takipTipi.aciklama : "";
    }

    tutarStr(val: number, paraBirimi: ParaBirimiEntity | null = null): string {
        // let temp = new Intl.NumberFormat('tr-TR', {style: 'currency', currency: 'TRY'}).format(val);
        if (!val) {
            val = 0.00;
        }
        return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2}).format(val) + " " + (paraBirimi ? paraBirimi?.kisa_isim : " TL");

  }

    tutarStrIstatistik(val: number, paraBirimi: ParaBirimiEntity | null = null): string {
        // let temp = new Intl.NumberFormat('tr-TR', {style: 'currency', currency: 'TRY'}).format(val);
        if (!val) {
            val = 0.00;
        }
        return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2}).format(val) + " " + (paraBirimi ? paraBirimi?.kisa_isim : " ₺");

    }

    newTutarStr(val: number): string {
        if (!val) {
            val = 0.00;
        }
        return new Intl.NumberFormat('tr-TR', {minimumFractionDigits: 2}).format(val);
    }

  async takipAcOnay():Promise<void>{
    const result = await Swal.fire({
      title: '<strong>Takip Açma Onayı</strong>',
      icon: "warning",
      allowOutsideClick: false,
      html: `
                <div style="text-align: left; padding: 10px;">
                    <div style="margin-bottom: 15px;">
                        <label class="swal2-checkbox" style="display: flex; align-items: center; margin-bottom: 10px;">
                            <input id="tarafOnay" type="checkbox" class="swal2-checkbox" required style="margin-right: 8px;">
                            <span class="swal2-label">Takiplerimde yer alan <strong>taraf bilgilerinin doğru</strong> olduğunu onaylıyorum.</span>
                        </label>
                    </div>
                    <div style="margin-bottom: 15px;">
                        <label class="swal2-checkbox" style="display: flex; align-items: center; margin-bottom: 10px;">
                            <input id="takipOnay" type="checkbox" class="swal2-checkbox" required style="margin-right: 8px;">
                            <span class="swal2-label">Açmak istediğim <strong>takipleri kontrol ettiğimi</strong> onaylıyorum.</span>
                        </label>
                    </div>
                    <div style="background: #fff3cd; border: 1px solid #ffeaa7; border-radius: 6px; padding: 10px; margin: 10px 0;">
                        <p style="font-size: 14px; color: #856404; margin: 0; line-height: 1.3;">
                            <i class="mdi mdi-alert-circle-outline" style="margin-right: 5px;"></i>
                            Lütfen tüm bilgileri dikkatli bir şekilde kontrol ediniz.
                        </p>
                    </div>
                </div>
            `,
      confirmButtonText: 'Tamam',
      cancelButtonText: 'İptal',
      showCancelButton: true,
      preConfirm: function () {
        return new Promise( (resolve)=> {
          const tarafOnay = document.getElementById('tarafOnay') as HTMLInputElement;
          const takipOnay = document.getElementById('takipOnay') as HTMLInputElement;
          resolve({
            tarafOnay: tarafOnay?.checked,
            takipOnay: takipOnay?.checked
          })
        })
      }
    });

    if(result.isDismissed) {
      throw new Error("İşlem iptal edildi.");
    }

    if(!result.value.tarafOnay) {
      throw new Error("Lütfen taraf bilgilerinin doğru olduğunu onaylayın.");
    }

    if(!result.value.takipOnay) {
      throw new Error("Lütfen açılacak olan takiplerinizi kontrol ettiğinizi onaylayın.");
    }
  }

    oranStr(val: number) {
        if (!val) {
            val = 0
        }
        return val + "%";
    }

    setCookie(name:string,value:any,days:number) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days*24*60*60*1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }
    getCookie(name:string) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
    }
    eraseCookie(name:string) {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    changeUyapDateFormat(date: string): string {
        let tarih = new Date(date);
        let tarihObj = {
            gun: tarih.getDate(),
            ay: (tarih.getMonth() + 1),
            yil: tarih.getFullYear()
        }
        return `${tarihObj.gun}.${tarihObj.ay}.${tarihObj.yil}`;
    }

    tarihGecenSure(val: Date | null): string {
        let thisTime = new Date();                              // Bugün
        if (val === null)
            return "bos deger";
        let diff = thisTime.getTime() - val.getTime();
        let retvaldk = diff / (1000 * 60);                      // dk bazında fark
        let retvalsa = diff / (1000 * 60 * 60);                 // sa bazında fark
        let retvalgun = diff / (1000 * 60 * 60 * 24);           // gün bazında fark
        let retvalhafta = diff / (1000 * 60 * 60 * 24 * 7);     // hafta bazında fark
        let retvalay = diff / (1000 * 60 * 60 * 24 * 30);       // ay bazında fark
        let retvalyil = diff / (1000 * 60 * 60 * 24 * 365);     // yıl bazında fark
        if (retvaldk < 60)
            return Math.round(retvaldk).toString() + " dk";
        else if (retvalsa < 24)
            return Math.round(retvalsa).toString() + " saat";
        else if (retvalgun < 7)
            return Math.round(retvalgun).toString() + " gün";
        else if (retvalhafta < 5)
            return Math.round(retvalhafta).toString() + " hafta";
        else if (retvalay < 12)
            return Math.round(retvalay).toString() + " ay";
        else
            return Math.round(retvalyil).toString() + " yıl";
    }

    tarihFarkiDetayli(baslangicTarihi: Date, bitisTarihi: Date = new Date()): object {
        let subDate = bitisTarihi.getTime() - baslangicTarihi.getTime();
        let tarihAraligi = {
            gun: 0,
            ay: 0,
            yil: 0
        }
        tarihAraligi.yil = Math.floor(subDate / (1000 * 60 * 60 * 24 * 365));
        if (tarihAraligi.yil > 0) subDate -= (tarihAraligi.yil * 1000 * 60 * 60 * 24 * 365);
        tarihAraligi.ay = Math.floor(subDate / (1000 * 60 * 60 * 24 * 30));
        if (tarihAraligi.ay > 0) subDate -= (tarihAraligi.ay * 1000 * 60 * 60 * 24 * 30);
        tarihAraligi.gun = Math.ceil(subDate / (1000 * 60 * 60 * 24));
        return tarihAraligi;
    }

    tcKimlikNoValidate(tcKimlikNo: string): boolean {
        let value10 = Number(tcKimlikNo.toString().substring(10, 11));
        let value9 = Number(tcKimlikNo.toString().substring(9, 10));
        let odd = Number(tcKimlikNo.toString().substring(0, 1)) + Number(tcKimlikNo.toString().substring(2, 3)) +
            Number(tcKimlikNo.toString().substring(4, 5)) + Number(tcKimlikNo.toString().substring(6, 7)) +
            Number(tcKimlikNo.toString().substring(8, 9));
        let even = Number(tcKimlikNo.toString().substring(1, 2)) + Number(tcKimlikNo.toString().substring(3, 4)) +
            Number(tcKimlikNo.toString().substring(5, 6)) + Number(tcKimlikNo.toString().substring(7, 8));
        let digit10 = (odd * 7 - even) % 10;
        if (digit10 < 0) digit10 += 10;
        let total = (odd + even + value9) % 10;

        return !(digit10 != value9 || total != value10)
    }

    yabanciKimlikNoValidate(yabanciKimlikNo: string): boolean {
        let firstTwoValue = Number(yabanciKimlikNo.toString().substring(0, 2));
        return firstTwoValue == 99;
    }

    borcluIl(borclu: BorcluEntity): string {
        if (borclu.kisi_id != null) {
            if (borclu.kisi.varsayilan_adres != null) {
                if (borclu.kisi.varsayilan_adres.adres_turu.id == AdresTuru.mernis)
                    return 'Mernis Adresi';
                else if (borclu.kisi.varsayilan_adres.adres_turu.id == AdresTuru.mersis)
                    return 'Mersis Adresi';
                else if (borclu.kisi.varsayilan_adres.sehir != null)
                    return borclu.kisi.varsayilan_adres.sehir.isim;
                else
                    return 'Bilgi Yok';
            } else
                return 'Bilgi Yok';
        } else {
            if (borclu.kurum.varsayilan_adres != null) {
                if (borclu.kurum.varsayilan_adres.adres_turu.id == AdresTuru.mernis)
                    return 'Mernis Adresi';
                else if (borclu.kurum.varsayilan_adres.adres_turu.id == AdresTuru.mersis)
                    return 'Mersis Adresi';
                else if (borclu.kurum.varsayilan_adres.sehir != null)
                    return borclu.kurum.varsayilan_adres.sehir.isim;
                else
                    return 'Bilgi Yok';
            } else
                return 'Bilgi Yok';
        }
    }

    borcluIlce(borclu: BorcluEntity): string {
        if (borclu.kisi_id != null) {
            if (borclu.kisi.varsayilan_adres != null) {
                if (borclu.kisi.varsayilan_adres.adres_turu.id == AdresTuru.mernis)
                    return 'Mernis Adresi';
                else if (borclu.kisi.varsayilan_adres.adres_turu.id == AdresTuru.mersis)
                    return 'Mersis Adresi';
                else if (borclu.kisi.varsayilan_adres.ilce != null)
                    return borclu.kisi.varsayilan_adres.ilce.isim;
                else
                    return 'Bilgi Yok'
            } else
                return 'Bilgi Yok'
        } else {
            if (borclu.kurum.varsayilan_adres != null) {
                if (borclu.kurum.varsayilan_adres.adres_turu.id == AdresTuru.mernis)
                    return 'Mernis Adresi';
                else if (borclu.kurum.varsayilan_adres.adres_turu.id == AdresTuru.mersis)
                    return 'Mersis Adresi';
                else if (borclu.kurum.varsayilan_adres.ilce != null)
                    return borclu.kurum.varsayilan_adres.ilce.isim;
                else
                    return 'Bilgi Yok';
            } else
                return 'Bilgi Yok';
        }
    }

    arrRemoveItem(arr: Array<any>, item: any) {
        var index = arr.indexOf(item);
        if (index != -1) {
            arr.splice(index, 1);
        }
    }

    getOldestVadeTarihiFromAlacak(alacak: AlacakEntity): Date {
        let oldestVadeTarihi!: Date;
        alacak.alacak_kalemleri.forEach((alacakKalemi: AlacakKalemiEntity) => {
            if (alacakKalemi.alacak_kalemi_alani_id === AlacakKalemiAlani.asilAlacak) {
                let alacakKalemiVadeTarihi = new Date(alacakKalemi.vade_tarihi);
                if (!!oldestVadeTarihi || oldestVadeTarihi > alacakKalemiVadeTarihi) {
                    oldestVadeTarihi = alacakKalemiVadeTarihi;
                }
            }
        });
        return oldestVadeTarihi;
    }

    calculateMonthDiffBetweenDates(date1: Date, date2: Date) {
        let dateDiff = new Date(date2.getTime() - date1.getTime());
        let yearDiff = dateDiff.getUTCFullYear() - 1970;
        let monthDiff = dateDiff.getUTCMonth()
        return (yearDiff * 12) + monthDiff;
    }

    getUdfFromComponent(component_id: string, download: boolean = false, fileName: string = "dilekce", options: any = {}): Blob | null {
        let html = this.getPrintableHtml(component_id, false, false);

        if (!html) {
            app.$toast.error("HTML içeriği alınamadı");
            return null;
        }

        try {
            const converter = new window.htmlToUdf({
                defaultFamily: "Times New Roman",
                defaultSize: 12,
                ...options
            });

            const normalizedHtml = converter.normalize(html);
            const udfBlob = converter.getUdfBlob(normalizedHtml);

            if (download) {
                converter.downloadUdf(normalizedHtml, fileName);
                //app.$toast.success("UDF dosyası indirildi");
            }

            return udfBlob;
        } catch (error: any) {
            console.error("UDF dönüşüm hatası:", error);
            app.$toast.error("UDF dönüşümü başarısız: " + (error?.message || "Bilinmeyen hata"));
            return null;
        }
    }
    // UDF indirmeden önce, dosyanın UYAP Editör'de nasıl görüneceğini gösteren
    // round-trip önizleme HTML'i üretir. content.xml üretilir, sonra geri parse
    // edilip render edilir; böylece dönüştürmede kaybolan içerik (örn. nested
    // tablo sonrası elemanlar) indirilmeden fark edilir.
    getUdfPreviewHtml(component_id: string): string {
        let html = this.getPrintableHtml(component_id, false, false);
        if (!html) {
            return "<p>Önizleme için içerik bulunamadı.</p>";
        }
        try {
            const converter = new window.htmlToUdf({
                defaultFamily: "Times New Roman",
                defaultSize: 12
            });
            const normalizedHtml = converter.normalize(html);
            return converter.getUdfPreviewHtml(normalizedHtml);
        } catch (error: any) {
            console.error("UDF önizleme hatası:", error);
            return "<p>Önizleme oluşturulamadı: " + (error?.message || "Bilinmeyen hata") + "</p>";
        }
    }

    async getImzaliUdfFromComponent(component_id: string, download: boolean = false, fileName: string = "dilekce", options: any = {}): Blob | null{
        try{
            // imza kontrolu yap ve imza takiliysa imzalama yap...
            let cardList = await app.$imza.availableCards();
            if(cardList.length > 0){
                let udfBlob = this.getUdfFromComponent(component_id,false,fileName,options);
                let imzaliUdf = await app.$imza.dokumanImzala(udfBlob);
                let imzaliUdfBlob: Blob = app.$uyapHelper.base64toBlob(imzaliUdf, "application/octet-stream");
                if(download == true)
                    saveAs(imzaliUdfBlob,fileName+".udf");
                return imzaliUdfBlob;
            }
        }catch (e) {
            app.$toast.error(e.message);
            console.log(e);
        }
    }

    getPrintableHtml(component_id: string, delete_button: boolean = false, delete_islemler: boolean = false){
        let prtHtml:any = document.getElementById(component_id)?.cloneNode(true);
        // Bütün butonları sil
        if (delete_button) {
            let element = prtHtml?.getElementsByTagName("button"), index;
            for (index = element.length - 1; index >= 0; index--) {
                if (element[index]) {
                    if (element[index].parentElement.tagName == "TD")
                        element[index].parentElement.remove(element[index]);
                    else if (element[index].parentElement.tagName == "DIV")
                        element[index].parentElement.removeChild(element[index]);
                }
            }
        }
        // İşlemler kısmını sil. Tabloda İşlemler kolonu olmayabilir (ör. salt
        // okunur listeler); bu durumda silinecek bir şey yok.
        if (delete_islemler) {
            let element = prtHtml?.querySelector("[aria-label='İşlemler']");
            element?.parentElement?.removeChild(element);
        }
        // InnerHTML'e dönüştür
        return  prtHtml?.innerHTML;
    }

    printComponent(component_id: string, delete_button: boolean = false, delete_islemler: boolean = false) {
        // DataTable'ı kopyala

        let prtHtml = this.getPrintableHtml(component_id,delete_button,delete_islemler);
        // Bütün stylesheets al (CSS)
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
            stylesHtml += node.outerHTML;
        }
        // Çıktı ekranı
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');
        if (!WinPrint) {
            app.$toast.error("Yazdırma penceresi açılamadı. Tarayıcınızın açılır pencere engelleyicisini kontrol edin.");
            return;
        }
        WinPrint.document.write(`<!DOCTYPE html>
                                    <html>
                                      <head>
                                        ${stylesHtml}
                                      </head>
                                      <body>
                                        ${prtHtml}
                                      </body>
                                    </html>`);
        WinPrint.document.close();
        WinPrint.focus();
        // Pencereyi yazdırma/PDF kaydetme bittikten sonra kapat. print()'in hemen
        // ardından close() çağrılırsa "PDF olarak kaydet" seçildiğinde belge
        // pencereyle birlikte yok oluyor ve dosya oluşmuyor.
        WinPrint.onafterprint = () => WinPrint.close();
        // onfocus'a bağlanmak güvenilir değil: pencere handler atanmadan önce
        // odaklanırsa olay hiç tetiklenmiyor ve yazdırma diyaloğu açılmıyordu.
        setTimeout(() => WinPrint.print(), 500);
    }

    private formatTaksitTabloHucre(alan: string, satir: Record<string, unknown>): string {
        if (alan === 'tarih') {
            const tarih = satir.tarih;
            return tarih == null ? '-' : this.tarihStr(tarih as Date | string);
        }
        if (alan === 'index' || alan === 'faiz_isleyen_gun') {
            const deger = satir[alan];
            return deger == null ? '-' : String(deger);
        }
        if (TAKSIT_TABLO_TUTAR_ALANLARI.indexOf(alan) >= 0) {
            const tutar = satir[alan];
            return tutar == null ? '-' : this.tutarStr(tutar);
        }
        const diger = satir[alan];
        return diger == null ? '-' : String(diger);
    }

    private taksitTabloPdfKolonGenislikleri(tableW: number): number[] {
        const toplamAgirlik = TAKSIT_TABLO_PDF_KOLON_AGIRLIK.reduce((acc, w) => acc + w, 0);
        return TAKSIT_TABLO_PDF_KOLON_AGIRLIK.map((w) => (tableW * w) / toplamAgirlik);
    }

    private async indirTaksitTabloPdf(params: {
        title: string;
        items: Array<Record<string, unknown>>;
        anaPara?: number | null;
        isleyenFaiz?: number | null;
    }): Promise<void> {
        const [jspdfModule, fontlar] = await Promise.all([
            import('jspdf'),
            import('@/helpers/pdfFontlar'),
        ]);
        const JsPDF = jspdfModule.jsPDF || jspdfModule.default;
        if (!JsPDF) {
            throw new Error('jsPDF yüklenemedi');
        }
        const {title, items, anaPara, isleyenFaiz} = params;
        const doc = new JsPDF({orientation: 'landscape', unit: 'mm', format: 'a4'});
        // jsPDF'in standart fontları CP1252 ile sınırlı; ı/İ/ş/ğ için gömülü font şart.
        const fontAile = fontlar.PDF_FONT_AILE;
        doc.addFileToVFS('Roboto-Regular-tr.ttf', fontlar.ROBOTO_NORMAL_TTF_BASE64);
        doc.addFont('Roboto-Regular-tr.ttf', fontAile, 'normal');
        doc.addFileToVFS('Roboto-Bold-tr.ttf', fontlar.ROBOTO_BOLD_TTF_BASE64);
        doc.addFont('Roboto-Bold-tr.ttf', fontAile, 'bold');
        doc.setFont(fontAile, 'normal');
        const marginX = 6;
        const marginTop = 8;
        const marginBottom = 10;
        const pageW = doc.internal.pageSize.getWidth();
        const pageH = doc.internal.pageSize.getHeight();
        const tableW = pageW - marginX * 2;
        const colWidths = this.taksitTabloPdfKolonGenislikleri(tableW);
        const tutarCols = new Set(TAKSIT_TABLO_TUTAR_ALANLARI);
        const centerCols = new Set(['index', 'faiz_isleyen_gun', 'tarih']);
        const lineH = 2.8;
        const fileName = (this.seoUrl(title) || 'taksit') + '-taksit.pdf';

        const kolonSol = (colIdx: number): number => {
            let x = marginX;
            for (let i = 0; i < colIdx; i++) {
                x += colWidths[i];
            }
            return x;
        };

        const drawTableRow = (
            cells: string[],
            yTop: number,
            header: boolean,
            stripe: boolean
        ): number => {
            const fontSize = header ? 6.2 : 6.5;
            doc.setFont(fontAile, header ? 'bold' : 'normal');
            doc.setFontSize(fontSize);
            let maxLines = 1;
            const cellLines: string[][] = cells.map((text, colIdx) => {
                const parts = String(text).split('\n');
                let lines: string[] = [];
                parts.forEach((part) => {
                    lines = lines.concat(doc.splitTextToSize(part, colWidths[colIdx] - 1.6));
                });
                if (lines.length > maxLines) {
                    maxLines = lines.length;
                }
                return lines;
            });
            const rowH = Math.max(header ? 10 : 5.5, maxLines * lineH + (header ? 3 : 2));

            cells.forEach((_, colIdx) => {
                const x = kolonSol(colIdx);
                const w = colWidths[colIdx];
                doc.setDrawColor(header ? 75 : 200, header ? 154 : 210, header ? 249 : 220);
                doc.setLineWidth(header ? 0.15 : 0.08);
                if (header) {
                    doc.setFillColor(91, 154, 249);
                    doc.rect(x, yTop, w, rowH, 'FD');
                } else {
                    if (stripe) {
                        doc.setFillColor(248, 250, 252);
                        doc.rect(x, yTop, w, rowH, 'FD');
                    }
                    doc.rect(x, yTop, w, rowH, 'S');
                }

                const lines = cellLines[colIdx];
                const colKey = TAKSIT_TABLO_HEADERS[colIdx].value;
                const alignRight = tutarCols.has(colKey);
                const alignCenter = header || centerCols.has(colKey);
                const blockH = lines.length * lineH;
                const startY = yTop + (rowH - blockH) / 2 + lineH * 0.85;

                if (header) {
                    doc.setTextColor(255, 255, 255);
                } else {
                    doc.setTextColor(29, 41, 57);
                }

                lines.forEach((line: string, lineIdx: number) => {
                    const textY = startY + lineIdx * lineH;
                    if (alignRight) {
                        doc.text(line, x + w - 0.9, textY, {align: 'right'});
                    } else if (alignCenter) {
                        doc.text(line, x + w / 2, textY, {align: 'center'});
                    } else {
                        doc.text(line, x + 0.9, textY);
                    }
                });
            });

            doc.setTextColor(0, 0, 0);
            return rowH;
        };

        let y = marginTop;
        doc.setFont(fontAile, 'bold');
        doc.setFontSize(13);
        doc.setTextColor(29, 41, 57);
        doc.text(title, marginX, y);
        y += 3;
        doc.setDrawColor(91, 154, 249);
        doc.setLineWidth(0.5);
        doc.line(marginX, y, pageW - marginX, y);
        y += 5;

        const headerCells = TAKSIT_TABLO_HEADERS.map((h) => {
            return TAKSIT_TABLO_PDF_BASLIK[h.value] || h.text;
        });
        y += drawTableRow(headerCells, y, true, false);

        items.forEach((satir, rowIdx) => {
            if (y > pageH - marginBottom - 6) {
                doc.addPage();
                y = marginTop;
                y += drawTableRow(headerCells, y, true, false);
            }
            const cells = TAKSIT_TABLO_HEADERS.map((col) =>
                this.formatTaksitTabloHucre(col.value, satir)
            );
            y += drawTableRow(cells, y, false, rowIdx % 2 === 1);
        });

        if (y > pageH - marginBottom - 22) {
            doc.addPage();
            y = marginTop;
        }
        y += 5;

        const borcTutari = anaPara == null ? '0,00 TL' : this.newTutarStr(anaPara);
        const faizTutari = isleyenFaiz == null ? '0,00 TL' : this.newTutarStr(isleyenFaiz);
        const toplamBorc = (anaPara == null && isleyenFaiz == null)
            ? '0,00 TL'
            : this.newTutarStr((anaPara || 0) + (isleyenFaiz || 0));

        const ozetItems = [
            {label: 'Borç Tutarı', value: borcTutari, strong: false},
            {label: 'Faiz Tutarı', value: faizTutari, strong: false},
            {label: 'Toplam Borç', value: toplamBorc, strong: true},
        ];
        const gap = 4;
        const boxW = (tableW - gap * 2) / 3;
        const boxH = 14;

        ozetItems.forEach((ozet, idx) => {
            const bx = marginX + idx * (boxW + gap);
            doc.setDrawColor(230, 232, 235);
            doc.setFillColor(255, 255, 255);
            doc.roundedRect(bx, y, boxW, boxH, 2, 2, 'FD');
            doc.setFont(fontAile, 'normal');
            doc.setFontSize(7);
            doc.setTextColor(100, 116, 139);
            doc.text(ozet.label, bx + 3, y + 5);
            doc.setFont(fontAile, ozet.strong ? 'bold' : 'normal');
            doc.setFontSize(ozet.strong ? 10.5 : 10);
            doc.setTextColor(ozet.strong ? 91 : 29, ozet.strong ? 154 : 41, ozet.strong ? 249 : 57);
            doc.text(ozet.value, bx + 3, y + 11);
        });

        doc.setTextColor(0, 0, 0);
        doc.save(fileName);
    }

    /**
     * Taksit tablosunu veriden PDF olarak indirir (tarayıcı yazdırma diyaloğu kullanılmaz).
     */
    printTaksitTablo(params: {
        title: string;
        items: Array<Record<string, unknown>>;
        anaPara?: number | null;
        isleyenFaiz?: number | null;
    }): void {
        this.indirTaksitTabloPdf(params)
            .then(() => {
                app.$toast.success('Taksit listesi PDF olarak indirildi.');
            })
            .catch((error: Error) => {
                console.error('Taksit PDF hatası:', error);
                app.$toast.error('Taksit listesi PDF oluşturulamadı.');
            });
    }

    seoUrl(text :string):string{
        text = text.replace(/\ /g,'-')
            .replace(/\(/g,'-')
            .replace(/\)/g,'-')
            .replace(/\//g,'-')
            .replace(/\\/g,'-');
        return this.trToEn(text);
    }
    trToEn(text:string):string{
        return text.toLowerCase()
            .replace(/Ç/g, 'c')
            .replace(/ç/g, 'c')
            .replace(/ö/g, 'o')
            .replace(/Ö/g, 'o')
            .replace(/Ü/g, 'u')
            .replace(/ü/g, 'u')
            .replace(/Ğ/g, 'g')
            .replace(/ğ/g, 'g')
            .replace(/Ş/g, 's')
            .replace(/ş/g, 's')
            .replace(/İ/g, 'i')
            .replace(/ı/g, 'i')
    }
    tutarToText(sayi: any) {
        if (typeof sayi == "number")
            sayi = sayi.toFixed(2).toString();
        sayi = sayi.replace(".", ",");
        let rakam = sayi.replace(/\B(?=(\d{3})+(?!\d))/g, ".").split(",");
        let tamsayi = rakam[0];
        let ondalik = rakam[1] || "";

        const birler = ["", "Bir", "İki", "Üç", "Dört", "Beş", "Altı", "Yedi", "Sekiz", "Dokuz"];
        const onlar = ["", "On", "Yirmi", "Otuz", "Kırk", "Elli", "Altmış", "Yetmiş", "Seksen", "Doksan"];
        const binler = ["", "Bin", "Milyon", "Milyar", "Trilyon", "Katrilyon", "Kentilyon"];
        let sonuc:any = [];
        let adim = 0;

        for (let i = tamsayi.split(".").length; i > 0; i--) {
            sayi = tamsayi.split(".")[i - 1];
            if (sayi.length == 1)
                sayi = "00" + sayi;
            if (sayi.length == 2)
                sayi = "0" + sayi;
            let c = "";
            for (let j = 1; j < sayi.length + 1; j++) {
                if (j == 1 && sayi[j - 1] == 1)
                    c += "Yüz";
                else if (j == 1 && birler[sayi[j - 1]] != "")
                    c += birler[sayi[j - 1]] + "Yüz";
                else if (j == 2)
                    c += onlar[sayi[j - 1]];
                else if (j == 3 && tamsayi.length == 5 && sayi[j - 1] == 1 && adim == 1)
                    c += " ";
                else if (j == 3)
                    c += birler[sayi[j - 1]];
            }
            if (c != "")
                sonuc.push(c + binler[adim]);
            adim++;
        }
        if (sonuc.length != 0)
            sonuc = sonuc.reverse().join("");
        else
            sonuc = "";
        if (ondalik.length == 1)
            ondalik = ondalik + "0";
        if (ondalik != "") {
            if (ondalik != "00") sonuc += "Virgül"
            sonuc += onlar[ondalik[0]] + birler[ondalik[1]];
        }
        sonuc = sonuc.replace(/ /g, " ").trim();
        return sonuc;
    }

    async download(name: string, URL: string) {
        return new Promise((resolve, reject) => {
            app.$http({
                url: URL,
                method: 'GET',
                responseType: 'blob'
            }).then((response) => {
                const resolvedName = this.downloadNameFromResponse(response, name);
                let fileURL = window.URL.createObjectURL(new Blob([!!response.data ? response.data : response]));
                let fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', resolvedName);
                document.body.appendChild(fileLink);
                fileLink.click();
                resolve(response);
            }).catch(async (error) => {
                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        const jsonError = JSON.parse(text);
                        error.response.data = jsonError;
                    } catch (parseError) {
                        console.error('Blob parse hatası:', parseError);
                    }
                }
                new StatusCodeHelper().error(error);
                reject(error.message)
            });
        })
    }

    async downloadPost(name: string, URL: string, data: any) {
        try {
            const response = await app.$http({
                url: URL+"?" + new URLSearchParams(data).toString(),
                method: 'GET',
                responseType: 'blob'
            });
            const resolvedName = this.downloadNameFromResponse(response, name);
            let fileURL = window.URL.createObjectURL(new Blob([!!response.data ? response.data : response]));
            let fileLink = document.createElement('a');
            fileLink.href = fileURL;
            fileLink.setAttribute('download', resolvedName);
            document.body.appendChild(fileLink);
            fileLink.click();
        } catch (error) {
            // Blob request'lerinde error.response.data bir Blob olabilir
            if (error.response && error.response.data instanceof Blob) {
                try {
                    const text = await error.response.data.text();
                    const jsonError = JSON.parse(text);
                    error.response.data = jsonError;
                } catch (parseError) {
                    console.error('Blob parse hatası:', parseError);
                }
            }
            new StatusCodeHelper().error(error);
        }
    }

    async getBlobFromLink(URL: string):Promise<Blob> {
        return new Promise((resolve, reject) => {
            app.$http({
                url: URL,
                method: 'GET',
                responseType: 'blob'
            }).then((response) => {
                console.log("response Blob",response);
                return resolve(this.getBlobFromAxiosResponse(response));
            }).catch(async (error) => {
                if (error.response && error.response.data instanceof Blob) {
                    try {
                        const text = await error.response.data.text();
                        error.response.data = JSON.parse(text);
                    } catch (parseError) {
                        console.error('Blob parse hatası:', parseError);
                    }
                }
                new StatusCodeHelper().error(error);
                return reject(error);
            });
        })
    }

    uyapTebligatAdresSorgula(){
        // TODO: IcraTebligatTalebiAdresSorgula
    }

    turkishToUpper(str: string) {
        let letters: any = {
            "a": "A",
            "b": "B",
            "c": "C",
            "d": "D",
            "e": "E",
            "f": "F",
            "g": "G",
            "ğ": "Ğ",
            "h": "H",
            "ı": "I",
            "i": "İ",
            "j": "J",
            "k": "K",
            "l": "L",
            "m": "M",
            "n": "N",
            "o": "O",
            "ö": "Ö",
            "p": "P",
            "r": "R",
            "s": "S",
            "ş": "Ş",
            "t": "T",
            "u": "U",
            "ü": "Ü",
            "v": "V",
            "y": "Y",
            "z": "Z",
            "A": "A",
            "B": "B",
            "C": "C",
            "D": "D",
            "E": "E",
            "F": "F",
            "G": "G",
            "Ğ": "Ğ",
            "H": "H",
            "I": "I",
            "İ": "İ",
            "J": "J",
            "K": "K",
            "L": "L",
            "M": "M",
            "N": "N",
            "O": "O",
            "Ö": "Ö",
            "P": "P",
            "R": "R",
            "S": "S",
            "Ş": "Ş",
            "T": "T",
            "U": "U",
            "Ü": "Ü",
            "V": "V",
            "Y": "Y",
            "Z": "Z"
        }
        let out = "";
        for (var i = 0; i < str.length; i++) {
            if (typeof letters[str[i]] != "undefined")
                out += letters[str[i]];
            else
                out += str[i];
        }
        return out;
    }

    turkishToLower(str: string) {
        let letters: any = {"İ": "i", "I": "ı", "Ş": "ş", "Ğ": "ğ", "Ü": "ü", "Ö": "ö", "Ç": "ç"};
        str = str.replace(/(([İIŞĞÜÇÖ]))+/g, (letter: any) => {
            return letters[letter];
        })
        return str.toLowerCase();
    }

    onlyDigit(text: string) {
        return text.replace(/[^0-9]/g, "");
    }

    getDateNow(seperator: string, dateDiff: any, donemYil = false) {
        let today:Date|string = new Date();
        let dd:string|number = today.getDate();
        let mm:string|number = today.getMonth(); //January is 0!
        let yyyy = today.getFullYear();
        if (dateDiff) {
            if (dateDiff.indexOf("month") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setMonth(mm - dateDiff.split('-')[1].trim());
                } else {
                    today.setMonth(mm + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
            if (dateDiff.indexOf("day") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setDate(dd - dateDiff.split('-')[1].trim());
                } else {
                    today.setDate(dd + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
            if (dateDiff.indexOf("year") >= 0) {
                if (dateDiff.indexOf("-") >= 0) {
                    today.setFullYear(yyyy - dateDiff.split('-')[1].trim());
                } else {
                    today.setFullYear(yyyy + parseInt(dateDiff.split('+')[1].trim()));
                }
            }
        }
        dd = today.getDate();
        mm = today.getMonth() + 1;
        yyyy = today.getFullYear();

        if (!seperator)
            seperator = '/';
        if (dd < 10) {
            dd = '0' + dd
        }
        if (mm < 10) {
            mm = '0' + mm
        }
        today = dd + seperator + mm + seperator + yyyy;
        if (donemYil == true) {
            today = yyyy + seperator + mm;
        }
        return today;
    }

    onlyNumber(event: any) {
        let charCode = (event.keyCode) ? event.keyCode : event.which;
        // 44: Virgül 45:Tire 46: Nokta 101: E
        if (charCode == 101 || charCode == 44 || charCode == 45 || charCode == 46)
            event.preventDefault();
    }

    adlar(sahislar: Array<BorcluEntity | AlacakliEntity>) {
        let adlar: Array<string> = [];
        sahislar.forEach((sahis:any) => (sahis.muvekkil ? adlar.push(this.kisiKurumAd(sahis.muvekkil)) : adlar.push(this.kisiKurumAd(sahis))));
        return adlar.join(', ');
    }

    alacakKalemiAdiGetir(alacakKalemiAlaniId: number, alacakBelgeTuruId: number | null = null) {
        switch (alacakBelgeTuruId) {
            case AlacakBelgeTuru.nafaka: {
                return "Eklenen Nafaka";
            }
            default: {
                return AlacakKalemiAlaniLabel[AlacakKalemiAlani.takipSonrasiAsilAlacak]
            }
        }
    }

    convertToBase64(file: any) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    }

    normalizeBase64(b64Data: string): string {
        if (!b64Data || typeof b64Data !== 'string') return '';
        let s = b64Data.trim();
        const base64Part = s.split(';base64,');
        if (base64Part.length > 1) s = base64Part[1];
        s = s.replace(/<!--\[CDATA\[/g, '').replace(/\]\]-->/g, '');
        s = s.replace(/\s/g, '');
        s = s.replace(/-/g, '+').replace(/_/g, '/');
        const pad = s.length % 4;
        if (pad) s += '='.repeat(4 - pad);
        return s;
    }

    base64DataCleaner(data:EvrakB64FileObject):EvrakB64FileObject{
        let splitedB64 :any =  data.base64.split(";base64,");
        if(splitedB64.length > 1){
            data.base64 = splitedB64[1];
            data.type = splitedB64[0].split("data:")[1]
        }
        return data;
    }

    base64toBlob(base64Data:any, contentType:any): Blob {
        contentType = contentType || '';
        const sliceSize = 1024;
        const normalized = this.normalizeBase64(base64Data);
        const byteCharacters = window.atob(normalized);
        const bytesLength = byteCharacters.length;
        const slicesCount = Math.ceil(bytesLength / sliceSize);
        const byteArrays = new Array(slicesCount);

        for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
            const begin = sliceIndex * sliceSize;
            const end = Math.min(begin + sliceSize, bytesLength);

            const bytes = new Array(end - begin);
            for (let offset = begin, i = 0; offset < end; ++i, ++offset) {
                bytes[i] = byteCharacters[offset].charCodeAt(0);
            }
            byteArrays[sliceIndex] = new Uint8Array(bytes);
        }
        return new Blob(byteArrays, {type: contentType});
    }

    uyapB64toBlob(b64Data:any, contentType:any = null, sliceSize:any = null) {
        try{
            contentType = contentType || '';
            sliceSize = sliceSize || 512;
            const normalized = this.normalizeBase64(b64Data);
            let byteCharacters = window.atob(normalized);
            let byteArrays = [];
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                let slice = byteCharacters.slice(offset, offset + sliceSize);

                let byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }
                let byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }
            let blob = new Blob(byteArrays, {type: contentType});
            return blob;
        }catch (ex){
           throw new Error(ex.message);
        }
    }

    yasOgren(dogumTarihi: Date | string): number {
        let today = new Date();
        let birthDate = new Date(dogumTarihi);
        let age = today.getFullYear() - birthDate.getFullYear();
        let m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    }

    /**
     * Route path'ine göre takipDetay veya takipEkle store'unu belirler
     * @param routePath - Vue route path ($route.path)
     */
    getTakipStoreName(routePath: string): 'takipDetay' | 'takipEkle' {
        if (routePath.includes('/icrapro/takip/') && !routePath.includes('/takip-ekle/')) {
            return 'takipDetay';
        }
        return 'takipEkle';
    }

    /**
     * Store state'inden takip_bilgileri'ni getirir
     * @param storeState - Vuex store state
     * @param storeName - 'takipDetay' veya 'takipEkle'
     */
    getTakipBilgileri(storeState: any, storeName: 'takipDetay' | 'takipEkle'): any {
        const state = storeState[storeName];
        if (storeName === 'takipDetay') {
            return state?.takip?.takip_bilgileri || null;
        } else {
            return state?.item?.takip_bilgileri || null;
        }
    }

    /**
     * Takip bilgilerinden varsayılan form değerlerini oluşturur
     * @param takipBilgileri - getTakipBilgileri'den dönen değer
     * @param alacak - Opsiyonel. Para birimi bilgisi için parent alacak objesi
     */
    getDefaultFormValues(takipBilgileri: any, alacak?: any): {
        takip_oncesi_faiz_turu_id: number | null;
        takip_sonrasi_faiz_turu_id: number | null;
        faiz_hesap_sekli: any | null;
        para_birimi_id: number | null;
        para_birimi: any;
        oran_aylik_mi: boolean;
        takip_sonrasi_faiz_isle: boolean;
        takip_oncesi_faiz_isle: boolean;
        gecikme_tazminati_mi: boolean;
    } {
        const base = takipBilgileri && takipBilgileri.talepler && takipBilgileri.talepler[0]
            ? (() => {
                const takipAltTipi = takipBilgileri.talepler[0].takip_alt_tipi || {};
                return {
                    takip_oncesi_faiz_turu_id: takipAltTipi.takip_oncesi_faiz_turu_id || null,
                    takip_sonrasi_faiz_turu_id: takipAltTipi.takip_sonrasi_faiz_turu_id || null,
                    faiz_hesap_sekli: takipAltTipi.faiz_hesap_sekli || null,
                };
            })()
            : {
                takip_oncesi_faiz_turu_id: null,
                takip_sonrasi_faiz_turu_id: null,
                faiz_hesap_sekli: null,
            };

        return {
            ...base,
            para_birimi_id: alacak?.para_birimi_id ?? null,
            para_birimi: alacak?.para_birimi ?? null,
            oran_aylik_mi: false,
            takip_sonrasi_faiz_isle: true,
            takip_oncesi_faiz_isle: true,
            gecikme_tazminati_mi: false,
        };
    }

    /**
     * Route ve store'dan varsayılan form değerlerini tek seferde getirir (kısayol metod)
     * @param routePath - Vue route path ($route.path)
     * @param storeState - Vuex store state ($store.state)
     */
    getDefaultFormValuesFromStore(routePath: string, storeState: any, alacak?: any) {
        const storeName = this.getTakipStoreName(routePath);
        const takipBilgileri = this.getTakipBilgileri(storeState, storeName);
        return this.getDefaultFormValues(takipBilgileri, alacak);
    }

    /**
     * talepler[0].takip_tipi.ilamli (API: 0|1). Kök `talepler` veya `takip_bilgileri.talepler`.
     */
    private isIlamliTakipFromTakipPayload(root: any): boolean {
        if (!root) {
            return false;
        }
        const talepler =
            Array.isArray(root.talepler) && root.talepler.length > 0
                ? root.talepler
                : Array.isArray(root.takip_bilgileri?.talepler) &&
                  root.takip_bilgileri.talepler.length > 0
                    ? root.takip_bilgileri.talepler
                    : null;
        if (!talepler || !talepler[0]?.takip_tipi) {
            return false;
        }
        const v = talepler[0].takip_tipi.ilamli;
        return v === true || v === 1;
    }

    /**
     * İlamlı takip mi: güncel rota (takip ekle / takip detay) + Vuex `takipEkle.item` / `takipDetay.takip`.
     * Bileşende: this.$helper.isIlamliTakipFromTakipStore()
     */
    isIlamliTakipFromTakipStore(): boolean {
        const router = app.$router;
        const current = router && router.currentRoute;
        if (!current) {
            return false;
        }
        const path = current.path || "";
        const ekleItem = store.state.takipEkle?.item;
        const detayTakip = store.state.takipDetay?.takip;

        if (path.includes("/takip-ekle")) {
            return this.isIlamliTakipFromTakipPayload(ekleItem);
        }
        if (path.includes("/takip/") && !path.includes("/takip-ekle")) {
            return this.isIlamliTakipFromTakipPayload(detayTakip);
        }
        return (
            this.isIlamliTakipFromTakipPayload(detayTakip) ||
            this.isIlamliTakipFromTakipPayload(ekleItem)
        );
    }

    async saveFaizTuru(faizTuru: FaizTuruEntity, takipId?: number | string) {
        let response = null;
        if (faizTuru && faizTuru.id != null) {
            response = await app.$http.put("/api/v1/faiz-turu/" + faizTuru.id, faizTuru);
        } else {
            if (takipId) {
                response = await app.$http.post("/api/v1/takip/" + takipId + "/faiz-turu/", faizTuru);
            } else {
                response = await app.$http.post("/api/v1/faiz-turu/", faizTuru);
            }
        }
        faizTuru.id = response.data.id;
        await this.saveFaizOranlar(faizTuru);
        return response.data.id;
    }

    async saveFaizOranlar(item: FaizTuruEntity) {
        if (item.faiz_oranlari) {
            for (const faizOran of item.faiz_oranlari) {
                if (faizOran && faizOran.id != null) {
                    await app.$http.put("/api/v1/faiz-oran/" + faizOran.id, faizOran);
                } else {
                    faizOran.faiz_turu_id = item.id;
                    await app.$http.post("/api/v1/faiz-oran/", faizOran);
                }
            }
        }
    }
}

export default function HelperPlugin(Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$helper = new Helper();
}
